import { render, staticRenderFns } from "./Checkboxes.vue?vue&type=template&id=2e0a12fe&scoped=true&"
import script from "./Checkboxes.vue?vue&type=script&lang=ts&"
export * from "./Checkboxes.vue?vue&type=script&lang=ts&"
import style0 from "./Checkboxes.vue?vue&type=style&index=0&id=2e0a12fe&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0a12fe",
  null
  
)

export default component.exports